import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Privacy() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-gradient-to-r from-slate-900 via-indigo-950 to-slate-900 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-slate-400 hover:text-white mb-6 text-sm transition-colors">
            &larr; {t("common.back_home", "Înapoi la pagina principală")}
          </Link>
          <h1 className="text-3xl font-bold text-white">
            {t("privacy.title", "Politica de Confidențialitate")}
          </h1>
          <p className="mt-2 text-slate-400 text-sm">
            {t("privacy.last_updated", "Ultima actualizare")}: 22.03.2026
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="prose prose-slate max-w-none text-slate-700 space-y-8">

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">1. Introducere</h2>
            <p>
              Platforma <strong>iGROWth</strong> (denumită în continuare „Platforma"), operată de iGROWTH NEXUS SRL
              (denumită în continuare „Operatorul"), respectă confidențialitatea datelor dumneavoastră personale și se
              angajează să protejeze informațiile pe care ni le furnizați prin intermediul aplicației mobile și al
              platformei web.
            </p>
            <p>
              Această Politică de Confidențialitate descrie tipurile de date personale pe care le colectăm, modul în care
              le utilizăm, cum le protejăm și drepturile dumneavoastră în conformitate cu Regulamentul (UE) 2016/679
              (GDPR) și legislația românească aplicabilă.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">2. Operatorul de date</h2>
            <p>
              <strong>iGROWTH NEXUS SRL</strong><br />
              Email de contact: <a href="mailto:contact@sportiveducat.ro" className="text-indigo-600 hover:text-indigo-800">contact@sportiveducat.ro</a><br />
              Website: <a href="https://sportiveducat.ro" className="text-indigo-600 hover:text-indigo-800" target="_blank" rel="noopener noreferrer">sportiveducat.ro</a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">3. Datele personale colectate</h2>
            <p>Colectăm și prelucrăm următoarele categorii de date personale:</p>

            <h3 className="text-lg font-medium text-slate-800 mt-4 mb-2">3.1 Date furnizate direct de utilizator</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>Nume și prenume</li>
              <li>Adresa de email</li>
              <li>Număr de telefon</li>
              <li>Data nașterii</li>
              <li>Fotografie de profil (opțional)</li>
              <li>Informații despre clubul sportiv și echipa din care face parte</li>
              <li>Date de contact ale tutorelui/părintelui (pentru sportivii minori)</li>
            </ul>

            <h3 className="text-lg font-medium text-slate-800 mt-4 mb-2">3.2 Date generate prin utilizarea Platformei</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>Prezența la sesiunile de antrenament</li>
              <li>Rezultatele la quiz-uri educaționale</li>
              <li>Punctajele și clasamentele de gamificare</li>
              <li>Metrici de performanță sportivă</li>
              <li>Istoricul plăților și facturilor</li>
              <li>Preferințele de limbă și setările aplicației</li>
            </ul>

            <h3 className="text-lg font-medium text-slate-800 mt-4 mb-2">3.3 Date tehnice colectate automat</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>Token-uri de dispozitiv pentru notificări push (Firebase Cloud Messaging)</li>
              <li>Tipul și platforma dispozitivului (Android)</li>
              <li>Adresa IP (în scopuri de securitate)</li>
              <li>Date de autentificare (token JWT, cookie-uri de sesiune)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">4. Scopurile prelucrării datelor</h2>
            <p>Prelucrăm datele dumneavoastră personale pentru următoarele scopuri:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Furnizarea serviciului:</strong> gestionarea cluburilor sportive, echipelor, sesiunilor de antrenament și comunicarea între antrenori, sportivi și părinți</li>
              <li><strong>Autentificare și securitate:</strong> crearea și gestionarea conturilor de utilizator, verificarea identității</li>
              <li><strong>Gamificare și educație:</strong> administrarea sistemului de puncte, clasamentelor, quiz-urilor educaționale și recompenselor</li>
              <li><strong>Comunicare:</strong> trimiterea de notificări push, remindere pentru sesiuni și comunicări administrative</li>
              <li><strong>Facturare:</strong> procesarea plăților prin Stripe și generarea facturilor</li>
              <li><strong>Îmbunătățirea serviciului:</strong> analizarea utilizării platformei pentru optimizarea funcționalităților</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">5. Temeiul legal al prelucrării</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Executarea contractului</strong> (Art. 6(1)(b) GDPR): prelucrarea necesară pentru furnizarea serviciilor platformei</li>
              <li><strong>Consimțământul</strong> (Art. 6(1)(a) GDPR): pentru trimiterea notificărilor push și comunicări de marketing</li>
              <li><strong>Interesul legitim</strong> (Art. 6(1)(f) GDPR): pentru securitatea platformei și prevenirea fraudei</li>
              <li><strong>Obligația legală</strong> (Art. 6(1)(c) GDPR): pentru conformitatea cu legislația fiscală (facturare)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">6. Protecția datelor minorilor</h2>
            <p>
              Platforma iGROWth este utilizată inclusiv de sportivi minori (sub 18 ani). Pentru minorii sub 16 ani,
              colectarea datelor se face numai cu consimțământul părintelui sau tutorelui legal. Datele de contact ale
              părintelui/tutorelui sunt stocate în profilul sportivului pentru a facilita comunicarea.
            </p>
            <p>
              Sportivii identificați ca vulnerabili beneficiază de protecție suplimentară, iar datele lor sunt accesibile
              doar antrenorilor și administratorilor clubului în mod direct responsabili.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">7. Partajarea datelor cu terți</h2>
            <p>Datele dumneavoastră pot fi partajate cu următorii terți, exclusiv în scopurile menționate:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Stripe, Inc.</strong> — procesarea plăților online (conform <a href="https://stripe.com/privacy" className="text-indigo-600 hover:text-indigo-800" target="_blank" rel="noopener noreferrer">Politicii Stripe</a>)</li>
              <li><strong>Google Firebase (Google LLC)</strong> — servicii de notificări push (FCM)</li>
              <li><strong>Supabase</strong> — găzduirea bazei de date (servere în UE)</li>
              <li><strong>Railway</strong> — găzduirea serverului backend</li>
              <li><strong>Brevo (Sendinblue)</strong> — trimiterea email-urilor tranzacționale</li>
            </ul>
            <p className="mt-2">
              Nu vindem, nu închiriem și nu partajăm datele dumneavoastră cu terți în scopuri de marketing.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">8. Transferul datelor în afara UE/SEE</h2>
            <p>
              Unii dintre furnizorii noștri de servicii (Google Firebase, Stripe) pot transfera date în afara Spațiului
              Economic European. Aceste transferuri sunt protejate prin Clauze Contractuale Standard aprobate de Comisia
              Europeană și/sau prin certificarea EU-US Data Privacy Framework.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">9. Durata stocării datelor</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Datele contului:</strong> pe durata existenței contului + 30 de zile după ștergere</li>
              <li><strong>Datele de facturare:</strong> 10 ani conform legislației fiscale românești</li>
              <li><strong>Datele de performanță sportivă:</strong> pe durata apartenenței la club</li>
              <li><strong>Log-uri de securitate:</strong> maximum 12 luni</li>
              <li><strong>Token-uri de dispozitiv:</strong> până la deconectarea din aplicație sau invalidarea token-ului</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">10. Drepturile dumneavoastră</h2>
            <p>În conformitate cu GDPR, aveți următoarele drepturi:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Dreptul de acces</strong> — puteți solicita o copie a datelor personale pe care le deținem</li>
              <li><strong>Dreptul la rectificare</strong> — puteți corecta datele inexacte din setările contului sau prin contactarea noastră</li>
              <li><strong>Dreptul la ștergere</strong> — puteți solicita ștergerea contului și a datelor asociate</li>
              <li><strong>Dreptul la restricționarea prelucrării</strong> — puteți solicita limitarea prelucrării datelor</li>
              <li><strong>Dreptul la portabilitatea datelor</strong> — puteți solicita datele într-un format structurat</li>
              <li><strong>Dreptul de opoziție</strong> — puteți obiecta la prelucrarea datelor bazate pe interes legitim</li>
              <li><strong>Dreptul de retragere a consimțământului</strong> — puteți retrage consimțământul oricând (ex: dezactivarea notificărilor push din setări)</li>
            </ul>
            <p className="mt-2">
              Pentru exercitarea acestor drepturi, contactați-ne la{" "}
              <a href="mailto:contact@sportiveducat.ro" className="text-indigo-600 hover:text-indigo-800">contact@sportiveducat.ro</a>.
              Vom răspunde în termen de 30 de zile.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">11. Securitatea datelor</h2>
            <p>Aplicăm măsuri tehnice și organizatorice adecvate pentru protejarea datelor:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Criptarea parolelor cu bcrypt</li>
              <li>Comunicații securizate prin HTTPS/TLS</li>
              <li>Autentificare prin token JWT cu expirare</li>
              <li>Limitarea ratei de acces (rate limiting) pentru prevenirea atacurilor</li>
              <li>Ștergere soft (soft delete) pentru prevenirea pierderii accidentale de date</li>
              <li>Acces bazat pe roluri (RBAC) — fiecare utilizator vede doar datele relevante rolului său</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">12. Cookie-uri</h2>
            <p>
              Platforma web utilizează cookie-uri strict necesare pentru funcționarea serviciului:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Token de autentificare</strong> — pentru menținerea sesiunii de login</li>
              <li><strong>Preferința de limbă</strong> — pentru memorarea limbii selectate (localStorage)</li>
            </ul>
            <p className="mt-2">
              Nu utilizăm cookie-uri de tracking, publicitate sau analiză comportamentală.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">13. Plângeri</h2>
            <p>
              Dacă considerați că drepturile dumneavoastră privind protecția datelor au fost încălcate, aveți dreptul de a
              depune o plângere la Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP):
            </p>
            <p className="mt-2">
              <strong>ANSPDCP</strong><br />
              B-dul G-ral. Gheorghe Magheru 28-30, Sector 1, București<br />
              Website: <a href="https://www.dataprotection.ro" className="text-indigo-600 hover:text-indigo-800" target="_blank" rel="noopener noreferrer">www.dataprotection.ro</a><br />
              Email: <a href="mailto:anspdcp@dataprotection.ro" className="text-indigo-600 hover:text-indigo-800">anspdcp@dataprotection.ro</a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">14. Modificări ale Politicii</h2>
            <p>
              Ne rezervăm dreptul de a actualiza această Politică de Confidențialitate. Orice modificări semnificative vor fi
              comunicate prin notificări în aplicație. Data ultimei actualizări este indicată la începutul documentului.
            </p>
          </section>

        </div>
      </div>

      {/* Footer */}
      <div className="bg-slate-50 border-t py-6 text-center text-sm text-slate-500">
        <span className="text-emerald-600">i</span>GROWth &copy; {new Date().getFullYear()} — <Link to="/terms" className="text-indigo-600 hover:text-indigo-800">Termeni și Condiții</Link>
      </div>
    </div>
  );
}
